import Api from "./wlgpi-api";

export default class {
  constructor() {
    this.loading = true;
    this.isLogged = false;
    this.details = [];
    this.urls = [];
  }
  async init(homeUrl, nonce, lang = null) {
    this.api = new Api("wlgpi/cartapi", homeUrl, nonce, lang);
    this.details = await this.api.get("user-details").then((response) => {
      if (response.error) {
        console.error(response.error);
      }

      return response;
    });
    this.urls = await this.api.get("user-urls").then((response) => {
      if (response.error) {
        console.error(response.error);
      }

      return response;
    });
    this.isLogged = this.details.login !== undefined;
    this.loading = false;
  }

  async logoutUser() {
    const response = await this.api.get("logout");

    if (response.error) {
      console.error(response.error);
    }

    location.reload();
  }
}
